"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enableRaygun = void 0;
var getRaygunInstance_1 = require("./getRaygunInstance");
/**
 * Enables Raygun error logging.
 * @param apiKey Raygun api key
 * @param version the application version
 */
function enableRaygun(apiKey, version) {
    var rg4js = (0, getRaygunInstance_1.getRaygunInstance)();
    // https://raygun.com/documentation/language-guides/javascript/vuejs/#step-2-configure-raygun
    rg4js("apiKey", apiKey);
    rg4js("enableCrashReporting", true);
    rg4js("setVersion", version);
    rg4js("saveIfOffline", true);
}
exports.enableRaygun = enableRaygun;
//# sourceMappingURL=enableRaygun.js.map